import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const get = createAsyncThunk(
  'sustainability/get',
  async (id, { dispatch }) => {
    try {
      const res = await api.get(`/admin/sustainability`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const edit = createAsyncThunk(
  'sustainability/edit',
  async ({ data, navigate }, { dispatch }) => {
    try {
      await api.put(`/admin/sustainability`, data);
      dispatch(
        setAlert({
          message: 'Sustainability updated successfully',
          alertType: 'success',
        }),
      );
      navigate(`/cms/sustainability`);
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
